document.addEventListener('DOMContentLoaded', function () {
  const productForm = document.querySelector('[id^="ProductForm-"]');
  const track = document.querySelector('[data-gallery-track]');
  const thumb = document.querySelector('[data-gallery-progress]');

  if (productForm) {
    const variantIdInput = productForm.querySelector('[data-product-variant-id]');
    const priceEl = document.querySelector('[id^="ProductPrice-"]');
    const addToCartBtn = productForm.querySelector('[data-add-to-cart]');
    const isComingSoon =
      addToCartBtn &&
      addToCartBtn.getAttribute('data-coming-soon') === 'true';
    const optionInputs = document.querySelectorAll('.product-page [data-variant-option]');
    const sizeLabels = document.querySelectorAll('.product-page [data-size-option]');
    const variantsScript = document.querySelector('[data-product-variants-json]');

    let variants = [];
    const moneyFormat =
      window.Shopify && window.Shopify.money_format
        ? window.Shopify.money_format
        : null;

    if (variantsScript) {
      try {
        variants = JSON.parse(variantsScript.textContent);
      } catch (e) {
        variants = [];
      }
    }

    function formatMoney(cents) {
      if (
        window.Shopify &&
        typeof window.Shopify.formatMoney === 'function' &&
        moneyFormat
      ) {
        return window.Shopify.formatMoney(cents, moneyFormat);
      }

      return (Number(cents) / 100).toFixed(2);
    }

    function getSelectedInput() {
      return document.querySelector('.product-page [data-variant-option]:checked');
    }

    function getSelectedLabel() {
      const selectedInput = getSelectedInput();
      return selectedInput ? selectedInput.closest('[data-size-option]') : null;
    }

    function clearAllSelections() {
      sizeLabels.forEach(function (label) {
        label.classList.remove('is-selected');

        const input = label.querySelector('[data-variant-option]');
        if (input) {
          input.checked = false;
        }
      });
    }

    function setButtonState(state) {
      if (!addToCartBtn) return;

      if (isComingSoon) {
        addToCartBtn.disabled = true;
        addToCartBtn.textContent = 'coming soon';
        return;
      }

      if (state === 'available') {
        addToCartBtn.disabled = false;
        addToCartBtn.textContent = 'add to bag';
        return;
      }

      if (state === 'soldout') {
        addToCartBtn.disabled = true;
        addToCartBtn.textContent = 'sold out';
        return;
      }

      if (state === 'adding') {
        addToCartBtn.disabled = true;
        addToCartBtn.textContent = 'adding...';
        return;
      }

      if (state === 'added') {
        addToCartBtn.disabled = false;
        addToCartBtn.textContent = 'added';
      }
    }

    function updateSizeVisualState() {
      sizeLabels.forEach(function (label) {
        const input = label.querySelector('[data-variant-option]');
        const available = label.getAttribute('data-variant-available') === 'true';

        label.classList.remove('is-selected');

        if (available) {
          label.classList.remove('is-disabled');
        } else {
          label.classList.add('is-disabled');
        }

        if (input) {
          if (!available && input.checked) {
            input.checked = false;
          }

          if (input.checked && available) {
            label.classList.add('is-selected');
          }
        }
      });
    }

    function applyVariantStateFromLabel(label) {
      if (!label) {
        if (variantIdInput) {
          variantIdInput.value = '';
        }

        setButtonState('soldout');
        updateSizeVisualState();
        return;
      }

      const variantId = label.getAttribute('data-variant-id');
      const available = label.getAttribute('data-variant-available') === 'true';
      const price = label.getAttribute('data-variant-price');
      const priceFormatted = label.getAttribute('data-variant-price-formatted');

      if (variantIdInput && variantId) {
        variantIdInput.value = variantId;
      }

      if (priceEl && available) {
        if (priceFormatted) {
          priceEl.innerHTML = priceFormatted;
        } else if (price) {
          priceEl.textContent = formatMoney(price);
        }
      }

      if (available) {
        setButtonState('available');
      } else {
        setButtonState('soldout');
      }

      updateSizeVisualState();
    }

    function updateVariant() {
      const selectedLabel = getSelectedLabel();
      applyVariantStateFromLabel(selectedLabel);
    }

    function disableVariantLabel(label) {
      if (!label) return;

      label.setAttribute('data-variant-available', 'false');
      label.setAttribute('data-variant-quantity', '0');
      label.classList.add('is-disabled');
      label.classList.remove('is-selected');

      const input = label.querySelector('[data-variant-option]');
      if (input) {
        input.disabled = true;
        input.checked = false;
      }

      updateSizeVisualState();

      const selectedInput = getSelectedInput();
      if (!selectedInput) {
        setButtonState('soldout');
      }
    }

    async function fetchCart() {
      const response = await fetch('/cart.js', {
        method: 'GET',
        headers: {
          Accept: 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error('Failed to fetch cart');
      }

      return response.json();
    }

    function buildCartVariantMap(cart) {
      const map = new Map();

      if (!cart || !cart.items) return map;

      cart.items.forEach(function (item) {
        const variantId = Number(item.variant_id);
        const qty = Number(item.quantity || 0);

        if (!variantId) return;
        map.set(variantId, (map.get(variantId) || 0) + qty);
      });

      return map;
    }

    function syncProductAvailabilityFromCart(cartVariantMap) {
      sizeLabels.forEach(function (label) {
        const variantId = Number(label.getAttribute('data-variant-id') || '0');
        const inventoryManaged =
          label.getAttribute('data-variant-inventory-management') === 'true';
        const inventoryPolicy =
          label.getAttribute('data-variant-inventory-policy') || 'deny';
        const inventoryQty = Number(label.getAttribute('data-variant-quantity') || '0');
        const inCartQty = cartVariantMap.get(variantId) || 0;

        let available = label.getAttribute('data-variant-available') === 'true';

        if (inventoryManaged && inventoryPolicy !== 'continue') {
          available = inventoryQty - inCartQty > 0;
        }

        label.setAttribute('data-variant-available', available ? 'true' : 'false');

        const input = label.querySelector('[data-variant-option]');
        if (input) {
          input.disabled = !available;

          if (!available) {
            input.checked = false;
          }
        }

        if (available) {
          label.classList.remove('is-disabled');
        } else {
          label.classList.add('is-disabled');
          label.classList.remove('is-selected');
        }
      });

      let selectedInput = getSelectedInput();

      if (!selectedInput || selectedInput.disabled) {
        const firstAvailableLabel = Array.from(sizeLabels).find(function (label) {
          const input = label.querySelector('[data-variant-option]');
          return input && !input.disabled;
        });

        if (firstAvailableLabel) {
          const input = firstAvailableLabel.querySelector('[data-variant-option]');
          if (input) {
            input.checked = true;
          }
        } else {
          clearAllSelections();

          if (variantIdInput) {
            variantIdInput.value = '';
          }
        }
      }

      updateVariant();
    }

    async function syncProductWithCart() {
      try {
        const cart = await fetchCart();
        const cartVariantMap = buildCartVariantMap(cart);
        syncProductAvailabilityFromCart(cartVariantMap);
      } catch (error) {
        console.error('Product cart sync error:', error);
      }
    }

    async function addProductToCart() {
      if (isComingSoon) return;

      if (!variantIdInput || !variantIdInput.value) return;

      const selectedLabel = getSelectedLabel();
      if (!selectedLabel) {
        setButtonState('soldout');
        return;
      }

      const isAvailable = selectedLabel.getAttribute('data-variant-available') === 'true';

      if (!isAvailable) {
        setButtonState('soldout');
        return;
      }

      try {
        setButtonState('adding');

        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            id: Number(variantIdInput.value),
            quantity: 1
          })
        });

        if (!response.ok) {
          if (response.status === 422) {
            disableVariantLabel(selectedLabel);
            await syncProductWithCart();
            setButtonState('soldout');
            return;
          }

          throw new Error('Add to cart failed');
        }

        await response.json();

        if (window.CartDrawer && typeof window.CartDrawer.refresh === 'function') {
          await window.CartDrawer.refresh();
        }

        await syncProductWithCart();

        if (window.CartDrawer && typeof window.CartDrawer.open === 'function') {
          window.CartDrawer.open();
        }

        const updatedSelectedLabel = getSelectedLabel();
        const stillAvailable =
          updatedSelectedLabel &&
          updatedSelectedLabel.getAttribute('data-variant-available') === 'true';

        if (stillAvailable) {
          setButtonState('added');
          window.setTimeout(function () {
            updateVariant();
          }, 700);
        } else {
          setButtonState('soldout');
        }
      } catch (error) {
        console.error('Product add to cart error:', error);

        if (addToCartBtn) {
          addToCartBtn.textContent = 'error';
        }

        window.setTimeout(function () {
          updateVariant();
        }, 700);
      }
    }

    optionInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        updateVariant();
      });
    });

    productForm.addEventListener('submit', function (event) {
      event.preventDefault();
      addProductToCart();
    });

    updateVariant();
    syncProductWithCart();
  }

  const accordionToggle = document.querySelector('[data-accordion-toggle]');
  const accordionContent = document.querySelector('[data-accordion-content]');

  if (accordionToggle && accordionContent) {
    accordionToggle.addEventListener('click', function () {
      const isOpen = accordionContent.classList.contains('is-open');
      accordionContent.classList.toggle('is-open');
      accordionToggle.setAttribute('aria-expanded', String(!isOpen));
    });
  }

  if (track && thumb && window.matchMedia('(max-width: 989px)').matches) {
    function updateProgress() {
      const visibleWidth = track.clientWidth;
      const totalWidth = track.scrollWidth;
      const maxScroll = totalWidth - visibleWidth;

      if (!visibleWidth || !totalWidth) return;

      if (maxScroll <= 0) {
        thumb.style.width = '100%';
        thumb.style.transform = 'translateX(0)';
        return;
      }

      const thumbWidth = Math.max((visibleWidth / totalWidth) * visibleWidth, 40);
      const available = visibleWidth - thumbWidth;
      const ratio = maxScroll > 0 ? track.scrollLeft / maxScroll : 0;
      const x = available * ratio;

      thumb.style.width = thumbWidth + 'px';
      thumb.style.transform = 'translateX(' + x + 'px)';
    }

    function queueProgressUpdate() {
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          updateProgress();
        });
      });
    }

    track.addEventListener('scroll', updateProgress, { passive: true });
    window.addEventListener('resize', queueProgressUpdate);
    window.addEventListener('load', queueProgressUpdate);

    const galleryImages = track.querySelectorAll('img');
    galleryImages.forEach(function (img) {
      if (!img.complete) {
        img.addEventListener('load', queueProgressUpdate, { once: true });
      }
    });

    if (typeof ResizeObserver !== 'undefined') {
      const resizeObserver = new ResizeObserver(function () {
        queueProgressUpdate();
      });

      resizeObserver.observe(track);
    }

    queueProgressUpdate();
    setTimeout(queueProgressUpdate, 120);
    setTimeout(queueProgressUpdate, 300);
  }

  initProductRecommendations();
});

function initProductRecommendations() {
  const recommendationsContainer = document.querySelector('[data-product-recommendations]');
  if (!recommendationsContainer) return;

  const productId = recommendationsContainer.getAttribute('data-product-id');
  if (!productId) return;

  fetch(
    `/recommendations/products?section_id=product-recommendations&product_id=${productId}&limit=4`
  )
    .then(function (response) {
      if (!response.ok) {
        throw new Error('Recommendations request failed');
      }

      return response.text();
    })
    .then(function (html) {
      const wrapper = document.createElement('div');
      wrapper.innerHTML = html;

      const recommendationsContent = wrapper.querySelector('.product-related');
      if (!recommendationsContent) return;

      recommendationsContainer.innerHTML = recommendationsContent.outerHTML;

      if (window.initProductCardCart) {
        window.initProductCardCart(recommendationsContainer);
      }

      if (window.syncProductCardCart) {
        window.syncProductCardCart(recommendationsContainer);
      }
    })
    .catch(function (error) {
      console.error('Product recommendations error:', error);
    });
}